<template>
  <div id="register" class="register">
    <div class="wrapper">
      <div class="content">
        <div class="header">
          <div class="image"></div>
          <div class="tip">找回密码</div>
        </div>
        <div class="input-box">
          <span>手机号</span>
          <input class="phone" placeholder="请输入手机号" v-model="phone" type="text" maxlength="11"
            oninput="value=value.replace(/[^\d]/g,'')" />
        </div>
        <div class="input-box">
          <span>验证码</span>
          <input class="code" placeholder="短信验证码" v-model="code" type="text" maxlength="6" />
          <button id="retrieveCodeText" class="button" :style="{backgroundColor:activeColor}"
            v-on:click="phoneCodeClick">获取验证码</button>
        </div>
        <button class="nextbtn" :style="{backgroundColor:activeColor2}" @click="nextClick">下一步</button>
      </div>
    </div>
    <div id="captcha" :class="captchaConfig.config.product === 'bind' ? 'hideHeight' : ''">
      <AliCaptcha :captcha-config="captchaConfig" />
    </div>
  </div>
</template>

<script>
// 引入
import { Toast } from 'mint-ui'
import AliCaptcha from '../components/aliCaptcha.vue'

export default {
  data () {
    const captchaHandler = (captchaObj) => {
      window.captchaObj = captchaObj;
      captchaObj
      .appendTo("#captcha")
      .onReady(function () {
        console.log("ready");
      })
      .onNextReady(function () {
        console.log("nextReady");
      })
      .onBoxShow(function () {
        console.log("boxShow");
      })
      .onError(function (e) {
        console.log(e);
      })
      .onSuccess(() => {
        console.log(window._vueInstance,'window._vueInstance')
        if (window._vueInstance && window._vueInstance.captchaConfig.config.product === "bind") {
          window._vueInstance.validate();
        }
      });
    };
    return {
      phone: '',
      code: '',
      activeColor: '',
      activeColor2: '',
      timer: '', // 手机号 验证码倒计时
      timerCount: 60,
      codeabled: true,
      captchaConfig: {
        config: {
          captchaId: "347c38155fea93f1450cab541186c39f",
          language: "zho",
          product: "bind",
        },
        handler: captchaHandler,
      },
    }
  },
  methods: {
    phoneCodeClick: function () {
      if (this.utils.isNull(this.phone)) {
        Toast('请输入手机号！')
        return
      }
      if (!this.utils.isPhone(this.phone)) {
        Toast('请正确输入手机号！')
        return
      }
      if (this.timerCount !== 60) {
        return
      }

      if (this.codeabled === true) {
        if (this.captchaConfig.config.product === 'bind') {
          // bind模式：弹出验证框，验证成功后由 onSuccess 回调触发 validate
          window.captchaObj.showCaptcha();
        } else {
          // 非bind模式：直接获取验证结果后发送短信
          this.validate();
        }
      }
    },
    validate () {
      let result = window.captchaObj.getValidate();
      if (!result) {
        alert('请先完成验证！');
        return;
      }
      let params = {
        phone: this.phone,
        captchaOutput: result.captcha_output,
        genTime: result.gen_time,
        lotNumber: result.lot_number,
        passToken: result.pass_token
      }
      var _this = this
      this.utils.POST(this.accountUrl + '/account/sendsms', { phone: this.phone }, function (response) {
        console.log('========短信发送成功')
        if (parseInt(response.code) === 0) {
          _this.countDown()
          Toast('短信已发送成功')
        }
      })
    },
    countDown: function () { // 倒计时
      console.log('倒计时==========')
      this.codeabled = false
      var _this = this
      this.timer = setInterval(function () {
        if (_this.timerCount > 0) {
          --_this.timerCount
          document.getElementById('retrieveCodeText').innerText = '已发送（' + _this.timerCount + 's）'
          console.log('倒计时==========' + _this.timerCount)
        } else {
          clearInterval(_this.timer)
          document.getElementById('retrieveCodeText').innerText = '重新获取'
          _this.timerCount = 60
          _this.codeabled = true
        }
      }, 1000)
    },
    checkParam: function () {
      if (this.utils.isNull(this.phone)) {
        Toast('请输入手机号！')
        return false
      }
      if (!this.utils.isPhone(this.phone)) {
        Toast('请正确输入手机号！')
        return false
      }
      if (this.utils.isNull(this.code)) {
        Toast('请输入验证码！')
        return false
      }
      return true
    },
    nextClick: function () {
      if (this.checkParam() === false) {
        return
      }
      var _this = this
      let param = {
        phone: this.phone,
        code: this.code
      }
      this.utils.POST(this.accountUrl + '/account/passwordSms/validation', param, function (response) {
        if (parseInt(response.code) === 0) {
          clearInterval(_this.timer)
          _this.$router.push({ path: 'retrieve2', query: { phone: _this.phone } })
        }
      })
    }
  },
  watch: {
    phone: function (val) {
      if (val.length >= 11) {
        this.phone = val.slice(0, 11)
      } else {
        return
      }
      this.activeColor = '#fecdcd'
      if (this.utils.isPhone(this.phone)) {
        this.activeColor = '#c41335'
      } else {
        Toast('请正确输入手机号')
      }
    },
    isActive: function (val) {
      this.activeColor2 = '#fecdcd'
      if (val === true) {
        this.activeColor2 = '#c41335'
      }
    }
  },
  computed: {
    isActive: function () {
      if (!this.utils.isNull(this.phone) && !this.utils.isNull(this.code)) {
        return true
      }
      return false
    }
  },
  components: { // 注册组件
    AliCaptcha
  },
  mounted () {
    window._vueInstance = this;
  }
}
</script>

<style scoped>
.wrapper {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
}
.wrapper .content {
  position: absolute;
  top: 18px;
  left: 15px;
  right: 15px;
  width: calc(100% - 30px);
  height: 250px;
  background-color: #ffffff;
}
.wrapper .content .header {
  position: absolute;
  top: 17px;
  left: 20px;
  right: 20px;
  height: 20px;
}
.wrapper .content .header .image {
  position: absolute;
  top: 4px;
  left: 0px;
  width: 12.5px;
  height: 11px;
  background-image: url("../assets/icon-arrow-red.png");
  background-size: cover;
  background-position: center;
}
.wrapper .content .header .tip {
  position: absolute;
  top: 3px;
  left: 22px;
  height: 14px;
  line-height: 14px;
  font-size: 17px;
  font-weight: bold;
  color: #000000;
}
.content .input-box {
  position: relative;
  top: 55px;
  left: 20px;
  width: calc(100% - 40px);
  height: 54px;
  line-height: 54px;
  border-bottom: solid #eeeeee 1px;
  box-sizing: border-box;
}
.content .input-box span {
  position: absolute;
  font-size: 13px;
  color: #000000;
  top: 20px;
  height: 15px;
  line-height: 15px;
}
.content .input-box input {
  position: absolute;
  left: 70px;
  height: 53px;
  width: calc(100% - 70px);
  line-height: 53px;
  font-size: 15px;
  color: #000000;
  border: none;
  padding: 15px 0;
  line-height: 24px;
  /*background-color: pink;*/
}
.content .input-box input.code {
  width: calc(100% - 170px);
}
.content .input-box .button {
  position: absolute;
  top: 11px;
  right: 0px;
  width: 100px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background-color: #fecdcd;
  border-radius: 15px;
  color: #ffffff;
  font-size: 12px;
}
.content .nextbtn {
  position: relative;
  top: 75px;
  left: 20px;
  width: calc(100% - 40px);
  height: 40px;
  line-height: 40px;
  background-color: #fecdcd;
  text-align: center;
  color: #ffffff;
  font-size: 15px;
  border-radius: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/retrieve.vue